import { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { InputSwitch } from "primereact/inputswitch";
import { Button } from "react-bootstrap";
import { getEndpointUrl, getTimestamp } from "../../Utils/Common";

function UpdateChoiceGroupDialog({ visible, onHide, group, formElementId, onSuccess }) {
    const [name, setName] = useState("");
    const [required, setRequired] = useState(true);
    const [detail, setDetail] = useState("");
    const [isSubmitting, setSubmitting] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => {
        if (visible) {
            setName(group?.name ?? "");
            setRequired(!!group?.required);
            setDetail(group?.form_choices_details?.[0]?.detail ?? "");
            setError("");
        }
    }, [visible, group]);

    const accesToken = JSON.parse(localStorage.getItem("credentials")) || [];

    const handleSubmit = async () => {
        setError("");

        if (!group?.id) {
            setError("ID choice group tidak tersedia.");
            return;
        }
        if (!name.trim()) {
            setError("Nama group wajib diisi.");
            return;
        }

        setSubmitting(true);
        try {
            const payload = {
                form_element_id: parseInt(formElementId ?? group?.form_element_id, 10),
                name: name.trim(),
                required: required ? 1 : 0,
                // Kirim 'details' sebagai string sesuai spesifikasi
                details: (detail ?? "").toString().trim()
            };

            const res = await fetch(
                `${getEndpointUrl()}/v2/form_choice/${group.id}?v=${getTimestamp()}`,
                {
                    method: "PUT",
                    headers: new Headers({
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${accesToken}`,
                    }),
                    body: JSON.stringify(payload),
                }
            );

            const json = await res.json();
            if (json.status === "ok" && json.results) {
                onSuccess?.(json.results);
                onHide?.();
            } else {
                setError(json.message || "Gagal memperbarui data group");
            }
        } catch (err) {
            setError(err?.message || "Terjadi kesalahan jaringan");
        } finally {
            setSubmitting(false);
        }
    };

    const footer = (
        <div className="d-flex justify-content-end gap-2">
            <Button variant="outline-secondary" disabled={isSubmitting} onClick={onHide}>
                Batal
            </Button>
            <Button variant="primary" disabled={isSubmitting} onClick={handleSubmit}>
                {isSubmitting ? "Menyimpan..." : "Simpan Perubahan"}
            </Button>
        </div>
    );

    return (
        <Dialog
            header="Ubah Form Choice Group"
            visible={visible}
            onHide={onHide}
            style={{ width: "520px" }}
            modal
            footer={footer}
        >
            <div className="mb-3">
                <label className="form-label fw-semibold">Nama Group</label>
                <InputText
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    className="w-100 px-3"
                    placeholder="Nama group..."
                />
            </div>

            <div className="mb-3 d-flex align-items-center gap-2">
                <label className="form-label fw-semibold mb-0">Required</label>
                <InputSwitch checked={required} onChange={(e) => setRequired(!!e.value)} />
            </div>

            {/* <div className="mb-3">
                <label className="form-label fw-semibold">Detail (satu baris)</label>
                <InputText
                    value={detail}
                    onChange={(e) => setDetail(e.target.value)}
                    className="w-100 px-3"
                    placeholder="Contoh: Deskripsi dari HOHA 321"
                />
            </div> */}

            {error && <div className="alert alert-danger py-2">{error}</div>}
        </Dialog>
    );
}

export default UpdateChoiceGroupDialog;